import { HobbiesInterestsOptionIdType } from '@/pages/Onboarding/options/HobbiesInterests/types';

import { HOBBIES_INTERESTS_OPTIONS } from '../HOBBIES_INTERESTS_OPTIONS';

export const getHobbiesInterestsTitleById = (
  id: HobbiesInterestsOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return (
    HOBBIES_INTERESTS_OPTIONS.find((option) => option.id === id)?.title || null
  );
};

const DEFAULT: HobbiesInterestsOptionIdType = 'fitness_gym';

export const getHobbiesInterestsIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): HobbiesInterestsOptionIdType | null => {
  const id = HOBBIES_INTERESTS_OPTIONS.find(
    (option) => option.title === title,
  )?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
